import { render } from "./WritePage.vue?vue&type=template&id=512c6218&scoped=true"
import script from "./WritePage.vue?vue&type=script&lang=js"
export * from "./WritePage.vue?vue&type=script&lang=js"

import "./WritePage.vue?vue&type=style&index=0&id=512c6218&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-512c6218"]])

export default __exports__